module.exports = __webpack_public_path__ + "static/assets/9a2b4738446648557be6ffc033a6985e.gif";